// extracted by mini-css-extract-plugin
export default {"deviceButton":"ToggleSettingsButton_deviceButton__1M6U5","icon":"ToggleSettingsButton_icon__KAqeC","deviceButtonWithLabel":"ToggleSettingsButton_deviceButtonWithLabel__vbqeP"};